export function truncateText(text?: string) {
  if (!text) return '';
  text = text.trim();

  return text.length > 30 ? `${text.slice(0, 30)}...` : text;
}
